import { useState, type FormEvent } from "react";
import { LockKeyhole, ShieldCheck } from "lucide-react";
import { Button, ErrorBanner, Field, Input } from "../components/Ui";
import { requireSupabase } from "../lib/supabase";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    const { error: authError } = await requireSupabase().auth.signInWithPassword({
      email: email.trim().toLowerCase(),
      password
    });
    if (authError) setError("Anmeldung fehlgeschlagen. Bitte E-Mail-Adresse und Passwort prüfen.");
    setBusy(false);
  }

  return (
    <main className="login-page">
      <section className="login-brand">
        <div className="login-brand__mark">K&amp;S</div>
        <div>
          <span>Interne Lagerverwaltung</span>
          <h1>Lagersystem</h1>
          <p>Wareneingänge, Lagerplätze und Abholungen für Oberhausen und Merzenich.</p>
        </div>
      </section>
      <section className="login-panel">
        <div className="login-panel__icon"><LockKeyhole size={24} /></div>
        <h2>Sicher anmelden</h2>
        <p>Verwende ausschließlich dein persönlich freigeschaltetes K&amp;S-Konto.</p>
        {error && <ErrorBanner message={error} />}
        <form onSubmit={submit} className="form-stack">
          <Field label="E-Mail-Adresse">
            <Input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="username" required />
          </Field>
          <Field label="Passwort">
            <Input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required />
          </Field>
          <Button type="submit" disabled={busy}>{busy ? "Anmeldung läuft …" : "Anmelden"}</Button>
        </form>
        <div className="login-panel__security"><ShieldCheck size={17} /><span>Zugriff und Lagerzuordnung werden serverseitig geprüft.</span></div>
      </section>
    </main>
  );
}
